export default "__VITE_ASSET__BFMU8LYJ__"